import {
  differenceInHours,
  differenceInMinutes,
  formatDate,
  isValid,
  parseISO
} from 'lib/helpers/dateUtils';

import { LIVE_TRAINING_CONFIG } from '../components/LiveTrainingStep/lib/config';

const buildSessionDescription = (training, timezone) => {
  const startsAt = training?.starts_at;
  if (!startsAt) return null;

  const parsed = parseISO(startsAt);
  if (!isValid(parsed)) return null;

  const hours = differenceInHours(parsed, new Date());
  const variant =
    hours < 0 ? 'default' : hours <= 24 ? 'danger' : hours <= 48 ? 'warning' : 'default';

  const dateTime = formatDate(startsAt, timezone, 'MMM dd, h:mm a');
  if (!dateTime) return null;

  const endsAt = training?.ends_at ? parseISO(training.ends_at) : null;
  const durationMins = endsAt && isValid(endsAt) ? differenceInMinutes(endsAt, parsed) : null;

  return {
    text: `Date & time: ${dateTime}`,
    variant,
    suffix: durationMins > 0 ? `${durationMins} min` : null
  };
};

export const buildWorkingSessionConfig = (baseConfig, meetings, timezone) => {
  if (!meetings?.length) return baseConfig;

  const byName = new Map(meetings.filter((m) => m?.name).map((m) => [m.name.toLowerCase(), m]));

  const merged = { ...baseConfig };
  Object.entries(LIVE_TRAINING_CONFIG).forEach(([code, cfg]) => {
    const training = byName.get(cfg.meetingKey?.toLowerCase());
    const description = buildSessionDescription(training, timezone);
    if (!description) return;
    merged[code] = { ...merged[code], sidebarDescription: description };
  });

  return merged;
};
